import { PriceEditModalActions } from './actionNames'
import { AnyAction } from 'redux'
import initialState from './initialState'
import { cloneDeep, set, xor } from 'lodash'
import { PriceGridAction } from '../price/actionNames'

export default function(
  store: IPriceEditStore = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case PriceEditModalActions.OpenPriceEditModal:
      return {
        ...store,
        isOpen: true,
        roomId: action.roomId,
        startDate: action.startDate ? action.startDate : store.startDate,
        type: action.pType,
        data: undefined,
        initial: undefined,
        fields: [],
        errors: undefined,
        keepRestrictions: undefined,
      }
    case PriceEditModalActions.Save:
      return {
        ...store,
        loading: true,
      }
    case PriceGridAction.SetRoomSettingsAirbnbErrors:
      return {
        ...store,
        loading: false,
      }
    case PriceGridAction.SetRoomSettingsBookingErrors:
      return {
        ...store,
        loading: false,
      }
    case PriceGridAction.PutRoomSettingsGlobal:
      return {
        ...store,
        loading: false,
      }
    case PriceGridAction.LoadGlobalRoomSettings:
      return {
        ...store,
        loading: true,
      }
    case PriceGridAction.RequestNewPrices:
      return {
        ...store,
        loading: true,
      }
    case PriceGridAction.SetNewPricesLoading:
      return {
        ...store,
        loading: action.payload,
      }
    case PriceGridAction.PricesNewAccepted:
      return {
        ...store,
        loading: false,
      }
    case PriceEditModalActions.SetLoader:
      return {
        ...store,
        loading: action.payload,
      }
    case PriceEditModalActions.AddPeriod:
      return {
        ...store,
        data: store.data
          ? {
              ...store.data,
              periods: [
                ...store.data.periods,
                {
                  start: action.start,
                  end: action.end,
                },
              ],
            }
          : {
              periods: [
                {
                  start: action.start,
                  end: action.end,
                },
              ],
            },
      }
    case PriceEditModalActions.ClosePriceEditModal:
      return {
        ...store,
        isOpen: false,
        roomId: action.payload ? undefined : store.roomId,
        startDate: action.payload ? undefined : store.startDate,
        data: action.payload ? undefined : store.data,
        type: action.payload ? undefined : store.type,
        keepRestrictions: action.payload ? undefined : store.keepRestrictions,
      }
    case PriceEditModalActions.SetKeepRestrictions:
      return {
        ...store,
        keepRestrictions: action.payload,
      }
    case PriceEditModalActions.SetPeriod:
      return {
        ...store,
        data: store.data
          ? {
              ...store.data,
              periods: store.data.periods.map((period, index) =>
                index === action.payload.index
                  ? {
                      start: action.payload.start,
                      end: action.payload.end,
                    }
                  : period,
              ),
            }
          : store.data,
      }
    case PriceEditModalActions.RemovePeriod:
      return {
        ...store,
        data: {
          ...store.data,
          periods: store.data
            ? store.data.periods.filter(
                (period, index) => index !== action.payload,
              )
            : [],
        },
      }
    case PriceEditModalActions.SetRooms:
      return {
        ...store,
        data: {
          ...store.data,
          rooms: action.payload,
        },
      }
    case PriceEditModalActions.SetPrice:
      let prices =
        store.data && store.data.prices ? cloneDeep(store.data.prices) : {}

      set(prices, action.payload.path, action.payload.value)

      return {
        ...store,
        data: {
          ...store.data,
          prices: prices,
        },
      }
    case PriceEditModalActions.SetRestrictions:
      let restrictions =
        store.data && store.data.restrictions
          ? cloneDeep(store.data.restrictions)
          : {}

      set(restrictions, action.payload.path, action.payload.value)
      return {
        ...store,
        data: {
          ...store.data,
          restrictions: restrictions,
        },
      }
    case PriceEditModalActions.SetData:
      return {
        ...store,
        data: action.payload,
        initial: action.payload ? action.payload : store.initial,
      }
    case PriceEditModalActions.RegisterField:
      // only set when non existent
      return {
        ...store,
        fields: store.fields.includes(action.payload)
          ? store.fields
          : [...store.fields, action.payload],
      }
    case PriceEditModalActions.SetErrors:
      return {
        ...store,
        errors: action.errors,
        loading: false,
      }
    case PriceEditModalActions.SelectRoom:
      return {
        ...store,
        data: {
          ...store.data,
          rooms:
            store.data && store.data.rooms
              ? xor(store.data.rooms, action.payload)
              : action.payload,
        },
      }
    default:
      return store
  }
}

export interface IPriceEditStore {
  isOpen: boolean
  roomId: number | undefined
  startDate: Date | undefined
  data: IPriceEditData | undefined
  type: string | undefined
  initial: IPriceEditData | undefined
  fields: string[]
  errors: any
  loading: boolean
  keepRestrictions?: boolean
}

export interface IPriceEditData {
  periods: Array<{
    end: Date | undefined
    start: Date | undefined
  }>
  rooms: string[]
  prices: any
  restrictions: any
}
